import React from "react";
import "./Sidebar.css";
import logo from "../assets/Spark-Logo.png";
import { FiPlus } from "react-icons/fi";

function Sidebar({ chats, user, onNewChat, onLogout }) {
    return (
        <div className="sidebar">

            <div className="sidebar-logo">
                <img src={logo} className="Logo" alt="Sidebar icon" />
            </div>

            <div className="sidebar-middle">
                <nav className="sidebar-menu">

                    <div className="menu-item new-chat" onClick={onNewChat}>
                        <FiPlus className="icon" />
                        <span>New Chat</span>
                    </div>

                    <div className="chat-header">Previous Chats</div>

                    <div className="chat-list">
                        {chats && chats.length > 0 ? (
                            chats.map((chat) => (
                                <div className="chat-item" key={chat.id}>
                                    <span>{chat.title}</span>
                                </div>
                            ))
                        ) : (
                            <div className="empty-history">No chat history</div>
                        )}
                    </div>
                </nav>
            </div>

            <div className="user-panel">
                <div className="user-info">
                    <img
                        src={user?.avatar || "https://ui-avatars.com/api/?name=User"}
                        className="user-avatar"
                        alt="User"
                    />
                    <div className="user-details">
                        <div className="user-name">{user?.name}</div>
                    </div>
                </div>
                <button className="logout-button" onClick={onLogout}>Log Out</button>
            </div>

        </div>
    );
}

export default Sidebar;